import React from 'react'

import { Tabs } from 'antd'

import { useSearchParams } from '../../../../hooks'
import { getMessage } from '../../../../util/IntlMessages'
import { ActionCustomFields } from './components/ActionCustomFields'
import { ActionInfo } from './components/ActionInfo'
import { ActionTypeForm } from './components/ActionTypeForm'
import { PageHeader } from './components/PageHeader'
import { useActionType } from './hooks/useActionType'

export default function CreateActionTypePage() {
  const { isNewActionType } = useActionType()

  const [searchParams, setSearchParams] = useSearchParams()

  const activeTab = searchParams.get('tab') || '1'

  function setActiveTab(key) {
    setSearchParams({ tab: key })
  }

  return (
    <ActionTypeForm>
      <>
        <PageHeader />

        <Tabs type="card" activeKey={activeTab} onChange={setActiveTab}>
          <Tabs.TabPane tab={getMessage('actionTypeInfo')} key="1">
            <ActionInfo />
          </Tabs.TabPane>

          {!isNewActionType && (
            <Tabs.TabPane tab={getMessage('customFieldsInfo')} key="2">
              <ActionCustomFields />
            </Tabs.TabPane>
          )}
        </Tabs>
      </>
    </ActionTypeForm>
  )
}
